import { Component, type ReactNode } from 'react';
import { Result, Button } from 'antd';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error?: Error }> {
  state = { error: undefined as Error | undefined };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle={this.state.error?.message || 'Unexpected error'}
          extra={<Button onClick={() => location.reload()}>Reload</Button>}
        />
      );
    }
    return this.props.children as JSX.Element;
  }
}
